<template>
    <modal @close="$emit('close')" :show-title="true">
        <div slot="header">
            <h5 class="modal-title">{{$t('attenzione_label').toUpperCase()}}</h5>
        </div>
        <div slot="body">
            <div v-if="ingredients.length === 1">
                {{$t('out_of_stock_single_begin')}}:
            </div>
            <div v-else>
                {{$t('out_of_stock_multiple_begin')}}:
            </div>
            <div>
                <b v-for="ingredient in this.ingredients">
                    {{ingredient}} <br>
                </b>
            </div>
            <div v-if="ingredients.length === 1">
                {{$t('out_of_stock_single_end')}}
            </div>
            <div v-else>
                {{$t('out_of_stock_multiple_end')}}
            </div>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../partials/Modal';

    export default {
        name: "ModalOutOfStockIngredients",
        components: {Modal},
        props: ['ingredients']
    }
</script>

<style scoped>

</style>
